function clearInsightsSearchFilters(event) {
    event.preventDefault();
    event.target.innerHTML = 'Clearing...'
    const searchFilterForm = document.querySelector('.search-filter-module-inner > form')
    const newURL = new URL(searchFilterForm.action);
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('term')) {
        newURL.searchParams.set('term', currentParams.get('term'))
    }
    window.location = newURL.toString()
}

onReady(() => {
    const searchFilterForm = document.querySelector('.search-filter-module-inner > form')

    if (!searchFilterForm) {
        return
    }

    const navContainer = document.querySelector('.navigationcontainer')
    const langPrefix = searchFilterForm.dataset.lang === 'en' ? '' : `/${searchFilterForm.dataset.lang}`
    const closeFilterButtons = searchFilterForm.querySelectorAll('.filter-close');
    const clearSearchButton = searchFilterForm.querySelector('.search-clear-btn');
    const clearFilterButton = searchFilterForm.querySelectorAll('.footer-clear-all');
    const applyFilterButton = searchFilterForm.querySelector('.footer-btn');
    const termInput = searchFilterForm.querySelector('#search');
    const topicInput = searchFilterForm.querySelector('input[name="topic"]')
    const contentTypeInput = searchFilterForm.querySelector('input[name="type"]')
    const contentCardGridElement = document.querySelector('.content-cards-grid')
    const contentFilters = document.querySelectorAll('.checkbox.content-type-filter');
    const contentTopics = document.querySelectorAll('.checkbox.topic');
    let numberResult = contentCardGridElement ? contentCardGridElement.dataset.numberResults : 0;

    if ('analyticsEnabled' in searchFilterForm.dataset) {
        'dataLayer' in window && dataLayer.push({
            event: 'insights-search',
            search_term: termInput.value.trim(),
            topics: topicInput.value.trim(),
            content_types: contentTypeInput.value.trim(),
            total_results: numberResult,
            wpLoggedIn: document.body.classList.contains('logged-in')
                .toString(),
        })
    }
    if (termInput.value) {
        clearSearchButton.classList.add("show")
    }
    termInput.addEventListener('input', () => {
        if (termInput.value) {
            clearSearchButton.classList.add("show")
        }
        else {
            clearSearchButton.classList.remove("show")
        }
    })
    closeFilterButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault(); // Prevents any default behavior
            searchFilterForm.classList.toggle("open-filters");
            document.body.style.overflow = document.body.style.overflow === 'hidden' ? '' : 'hidden';
        })
    });

    clearSearchButton.addEventListener('click', (event) => {
        event.preventDefault()
        const params = new URLSearchParams(window.location.search);
        params.delete('term');
        window.location.search = params.toString();
    })

    window.addEventListener('click', () => {
        // Check if at least one checkbox is checked
        const isAnyContentChecked = Array.from(contentFilters)
            .some(filter => filter.checked);
        const isAnyTopicChecked = Array.from(contentTopics)
            .some(filter => filter.checked);

        // Set the display property of each clear filter button accordingly
        clearFilterButton.forEach(button => {
            button.classList.toggle('visible', isAnyContentChecked || isAnyTopicChecked)
        });
    });

    clearFilterButton.forEach((button) => button.addEventListener('click', clearInsightsSearchFilters))

    searchFilterForm.addEventListener('submit', (event) => {
        const selectedFilters = Array.from(searchFilterForm.querySelectorAll('input[type="checkbox"]:checked'))

        // Prevent from submiting if no filters has been selected
        if (selectedFilters.length === 0 && termInput.value.length === 0) {
            event.preventDefault()
            return
        }

        applyFilterButton.classList.add("applying")
        applyFilterButton.value = 'Applying'

        // If only 1 content type filter is selected, go to dedicated entry page
        const selectedContentTypes = searchFilterForm.querySelectorAll('.filter-post-type input[type=checkbox]:checked')
        if (selectedFilters.length === 1 && selectedContentTypes.length === 1 && termInput.value.length === 0) {
            event.preventDefault()
            const selectedContentTypeFilter = Array.from(selectedContentTypes)[0]
            window.location.href = `${langPrefix}/${selectedContentTypeFilter.dataset.slug}/`
            return
        }

        // Reformat parameters for pretty URLs
        topicInput.value = selectedFilters
            .filter((checkbox) => checkbox.classList.contains('topic'))
            .map((checkbox) => checkbox.value)
            .join(' ')
        contentTypeInput.value = selectedFilters
            .filter((checkbox) => checkbox.classList.contains('content-type-filter'))
            .map((checkbox) => checkbox.value)
            .join(' ')

        // Do not send empty parameters
        for (const input of [termInput, topicInput, contentTypeInput]) {
            if (input.value.length === 0) {
                input.name = ''
            }
        }
    })

    window.addEventListener('scroll', () => {
        if (window.scrollY) {
            document.querySelector('.search-filter-module-inner')
                .classList
                .add('slide-up');
            navContainer.classList.add('slide-up');
        }
        else {
            document.querySelector('.search-filter-module-inner')
                .classList
                .remove('slide-up');
            navContainer.classList.remove('slide-up');
        }
    });
})
